import moment from "moment";
import React from "react";
import { Panel, Table } from "react-bootstrap";
import Moment from "react-moment";
import RelatedPanel from "../Contacts/RelatedPanel";
import CallRecordPanel from "../Voice/CallRecordPanel";
import SmsRecordPanel from "../Voice/SmsRecordPanel";

const TaskPanel = ({ deal }) => {
  const tasks = deal.lm_tasks;
  const jobs = deal.jobs;

  return (
    <div className="row">
      <div className="col-sm-6">
        <CallRecordPanel callRecords={deal.call_records} />
        <RelatedPanel
          deals={deal.related_deals.filter((d) => d.id !== deal.id)}
          followUps={deal.related_follow_ups}
        />
      </div>
      <div className="col-sm-6">
        <SmsRecordPanel smsRecords={deal.sms_records} />

        <Panel bsStyle="success" className="compact-panel">
          <Panel.Heading>
            <Panel.Title componentClass="h3">Tasks</Panel.Title>
          </Panel.Heading>
          <Panel.Body style={{ padding: 3 }}>
            {tasks && tasks.length > 0 ? (
              <Table bordered condensed hover style={{ fontSize: 13 }}>
                <thead className="dark">
                  <tr>
                    <th style={{ width: "20%" }}>Type</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {tasks.map((task, index) => {
                    const taskURL = `${process.env.REACT_APP_LEADMACHINE_URL}/app#!/tasks/${task.lm_task_id}`;

                    return (
                      <tr key={index}>
                        <td>{task.task_type}</td>
                        <td>
                          <a
                            href={taskURL}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {task.description}
                          </a>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            ) : (
              <div style={{ margin: 10 }}>No tasks for this deal</div>
            )}
          </Panel.Body>
        </Panel>

        <Panel bsStyle="success" className="compact-panel">
          <Panel.Heading>
            <Panel.Title componentClass="h3">Background jobs</Panel.Title>
          </Panel.Heading>
          <Panel.Body style={{ padding: 3 }}>
            {jobs && jobs.length > 0 ? (
              <Table bordered condensed hover style={{ fontSize: 13 }}>
                <thead className="dark">
                  <tr>
                    <th>Description</th>
                    <th>Will run after</th>
                  </tr>
                </thead>
                <tbody>
                  {jobs.map((job, index) => {
                    return (
                      <tr key={index}>
                        <td>{job.description}</td>
                        <td>
                          <Moment format="MMM Do YYYY hh:mma">
                            {job.run_at}
                          </Moment>{" "}
                          {moment().isAfter(job.run_at) && (
                            <span> (overdue)</span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            ) : (
              <div style={{ margin: 10 }}>
                No outstanding jobs for this deal
              </div>
            )}
          </Panel.Body>
        </Panel>
      </div>
    </div>
  );
};
export default TaskPanel;
